var module = angular.module('octopusApp.dashboard');
var unTenantedDeploymentLogo = require('../../../img/tenants/un-tenanted-deployment-logo.png');
var tenantNotConnected = require('../../../img/tenants/tenant-not-connected.png');

module.directive('fastboard', function (octoUtil, taskStatusRenderer, octopusClient) {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        scope: {
            dashboardData: '=',
            dashboardType: '=',
            project: '=',
            release: '=',
            isTenantFiltered: '='
        },
        link: function (scope, element) {
            var previousHeadings = "";

            function fullRenderRequired(dashboardData) {
                var headings = angular.toJson({ a: dashboardData.Projects, b: dashboardData.Environments, c: dashboardData.ProjectGroups, d: dashboardData.Tenants, e: dashboardData.TenantPromotions, f: dashboardData.Groups });
                var required = headings !== previousHeadings;
                previousHeadings = headings;
                return required;
            }

            function nodeKey(envId, projId) { return [envId, "__", projId].join(''); }

            function sliceByProjectGroup(data) {
                var slices = {};
                _.each(data.ProjectGroups, function (projectGroup) {
                    var list = [];
                    if (projectGroup.EnvironmentIds.length === 0) {
                        list = data.Environments;
                    } else {
                        list = _.filter(data.Environments, function(env) {
                            return _.find(projectGroup.EnvironmentIds, function(id) {
                                return id === env.Id;
                            });
                        });
                    }

                    slices[projectGroup.Id] = {
                        environments: list,
                        projects: [],
                        projectIds: {}
                    };
                });

                _.each(data.Projects, function(project) {
                    slices[project.ProjectGroupId].projects.push(project);
                    slices[project.ProjectGroupId].projectIds[project.Id] = project;
                });

                return slices;
            }

            function getItemsForSlice(items, slice) {
                var itemDictionary = {};

                _.each(items, function(item) {
                    if (slice.projectIds[item.ProjectId]) {
                        var itemKey = nodeKey(item.EnvironmentId, item.ProjectId);
                        if (!itemDictionary[itemKey]) {
                            itemDictionary[itemKey] = [];
                        }
                        itemDictionary[itemKey].push(item);
                    }
                });

                return itemDictionary;
            }

            function getItemsForTenants(items, tenants) {
                var itemDictionary = {};

                _.each(items, function(item) {
                    if (item.TenantId === null || _.findIndex(tenants, function (tenant) { return tenant.Id === item.TenantId; }) !== -1) {
                        var itemKey = nodeKey(item.EnvironmentId, item.TenantId);
                        if (!itemDictionary[itemKey]) {
                            itemDictionary[itemKey] = [];
                        }
                        itemDictionary[itemKey].push(item);
                    }
                });

                return itemDictionary;
            }


            function getProjectEnvironmentTenantIndex(projects, environments, tenants) {
                var environmentIds = environments.map(function(e) { return e.Id; });

                var idx = {};
                projects.forEach(function(project) {
                    tenants.forEach(function(tenant) {
                        (tenant.ProjectEnvironments[project.Id] || []).forEach(function(envId){
                            if (environmentIds.indexOf(envId) === -1) {
                                return;
                            }
                            var key = nodeKey(envId, project.Id);
                            idx[key] = (idx[key] || []);
                            idx[key].push(tenant.Id);
                        }); });
                });
                return idx;
            }

            function getEnvironmentTenantIndex(project, environments, tenants) {
                var environmentIds = environments.map(function(e) { return e.Id; });

                var idx = {};
                tenants.forEach(function(tenant) {
                    (tenant.ProjectEnvironments[project.Id] || []).forEach(function(envId){
                        if (environmentIds.indexOf(envId) === -1) {
                            return;
                        }
                        var key = nodeKey(envId, tenant.Id);
                        idx[key] = (idx[key] || []);
                        idx[key].push(tenant.Id);
                    }); 
                });
                return idx;
            }

            function bindPopovers(domElements) {
                domElements.each(function () {
                    var domElement = $(this);
                    domElement.popover({
                        content: domElement.data("tip"),
                        trigger: 'hover',
                        placement: "bottom",
                        container: '#dynamicallyGeneratedContent'
                    });
                });
            }

            var matrices = [];
            var fullRender = function(data) {
                matrices = [];
                element.empty();
                switch (scope.dashboardType) {
                    case 'project':
                        renderProjectDashboard(data);
                        break;
                    default: 
                        renderDashboard(data);
                        break;
                }

                bindPopovers($('.tenant-status'), element);
            };

            function getTenantList(data, group, canPerformUntenantedDeployments, hasUntenantedDeployments){
                var tenants = data.Tenants;

                var untenantedProjectEnvironments = {};
                untenantedProjectEnvironments[scope.project.Id] = data.Environments.map(function (env) { return env.Id; });
                var untenantedObject = {
                    Id: '',
                    Name: 'Un-tenanted',
                    ProjectEnvironments: untenantedProjectEnvironments
                };

                if (group.CanonicalTagName) {
                    tenants = _.filter(tenants, function (tenant) {
                        return tenant.TenantTags.indexOf(group.CanonicalTagName) !== -1;
                    });
                } else if (group.IsGrouped) {
                    tenants = _.union((hasUntenantedDeployments ? [untenantedObject] : []), _.filter(tenants, function (tenant) { return tenant.TenantTags.length === 0; }));
                } else {
                    if (hasUntenantedDeployments || (canPerformUntenantedDeployments && !scope.isTenantFiltered)) {
                        tenants = _.union([untenantedObject], tenants);
                    }
                }

                return tenants;
            }

            var renderProjectDashboard = function (data) {
                if (!data.Items) {
                    return;
                }
                var canPerformUntenantedDeployments = data.Projects[0].CanPerformUntenantedDeployment;
                var hasUntenantedDeployments = _.filter(data.Items, function (item) {
                    return item.TenantId === null;
                }).length > 0;

                _.each((data.Groups || [{Name: 'Tenant'}]), function (group) {
                    var tenants = getTenantList(data, group, canPerformUntenantedDeployments, hasUntenantedDeployments);
                    if (tenants.length > 0) {
                        var groupItems = getItemsForTenants(data.Items, tenants);
                        var environmentTenantIndex = getEnvironmentTenantIndex(scope.project, data.Environments, tenants);

                        var undeployedTenantsInEnvironment = {};
                        _.each(data.Environments, function (environment) {
                            undeployedTenantsInEnvironment[environment.Id] = [];
                            if (_.filter(data.PromoteTo, function (promote) { return promote.Id === environment.Id; }).length > 0) {
                                _.each(tenants, function (tenant) {
                                    var key = nodeKey(environment.Id, tenant.Id);
                                    if (environmentTenantIndex[key]) {
                                        if (!groupItems[key]) {
                                            undeployedTenantsInEnvironment[environment.Id].push(tenant.Id);
                                        }
                                    }
                                });
                            }
                        });

                        var matrixElement = $("<div></div>");
                        element.append(matrixElement);

                        var matrix = new Octopus.ReleaseMatrix(matrixElement, taskStatusRenderer, octoUtil);
                        matrix.environments = data.Environments;
                        matrix.rows = tenants || data.Tenants;
                        matrix.heading = group.Name;
                        matrix.items = groupItems;
                        matrix.promotions = data.TenantPromotions;
                        matrix.promoteTo = data.PromoteTo;
                        matrix.environmentTenantIndex = environmentTenantIndex;
                        matrix.keyFromPair = function (env, tenant) { return nodeKey(env.Id, tenant.Id); };
                        matrix.renderGroupDeployButton = function (env, html) {
                            if (scope.release && group.CanonicalTagName && undeployedTenantsInEnvironment[env.Id].length > 0) {
                                var tagsQueryString = '';
                                if (data.SelectedTags) {
                                    tagsQueryString = '&tags=' + data.SelectedTags.join('&tags=');
                                }
                                var tenantsQueryString = '';
                                if (data.SelectedTenants) {
                                    tenantsQueryString = '&tenantIds=' + data.SelectedTenants.join('&tenantIds=');
                                }
                                html.push('<div class=""><a class="btn btn-xs" href="#/projects/' + scope.project.Slug + '/releases/' + scope.release.Version + '/deployments/create/to/' + env.Id + '?tags=' + group.CanonicalTagName + tagsQueryString + tenantsQueryString + '">Deploy to all</a></div>');
                            }
                        };
                        matrix.renderEmptyCell = function (key, html, promotion, tenant, environment) {
                            if (promotion) {
                                if (promotion.tenantId) {
                                    html.push('<div class="deploy-buttons"><a class="btn" href="#/projects/' + scope.project.Slug + '/releases/' + scope.release.Version + '/deployments/create/to/' + promotion.environment.Id + '?tenantIds=' + promotion.tenantId + '">Deploy</a></div>');
                                } else {
                                    html.push('<div class="deploy-buttons"><a class="btn" href="#/projects/' + scope.project.Slug + '/releases/' + scope.release.Version + '/deployments/create/to/' + promotion.Id + '">Deploy</a></div>');
                                }
                            } else {
                                var helpText = '';
                                if (!matrix.environmentTenantIndex[key]) {
                                    helpText = tenant.Name + ' is not connected to the ' + environment.Name + ' environment for this project';
                                    html.push('<div class="media"><div class="media-right media-middle"><span class="tenant-status" data-tip="' + helpText + '"><img class="media-object" style="width: 37px;opacity: 0.05" src="' + tenantNotConnected + '" /></span></div></div>');
                                } else if (!scope.release) {
                                    html.push('<div class="deploy-buttons" style="display: inline-block">');
                                    html.push('    <div class="tenant-status" data-tip="Please select a release from the dropdown above to enable deployment">');
                                    html.push('        <button class="btn disabled">Deploy</button>');
                                    html.push('    </div>');
                                    html.push('</div>');
                                } else {
                                    helpText = 'Release ' + scope.release.Version + ' can not be deployed to the ' + environment.Name + ' environment';
                                    html.push('<div class="media"><div class="media-right media-middle"><span class="tenant-status" data-tip="' + helpText + '"><img class="media-object" style="width: 37px;opacity: 0.05" src="' + tenantNotConnected + '" /></span></div></div>');
                                }
                            }
                        };
                        matrix.renderRowHeading = function (tenant, html) {
                            html.push('<div class="media">');
                            if (!tenant.Id) {
                                html.push('<div class="media-left media-middle"><img class="media-object" style="opacity: 0.1" src="' + unTenantedDeploymentLogo + '" /></div><div class="media-body media-middle">Un-tenanted</div>');
                            } else {
                                html.push('<div class="media-left media-middle"><a href="#/tenants/' + tenant.Id + '"><img class="media-object" src="' + octopusClient.resolve(tenant.Links['Logo']) + '" /></a></div><div class="media-body media-middle"><a href="#/tenants/' + tenant.Id + '">' + octoUtil.escapeHtml(tenant.Name) + '</a></div>');
                                if (tenant.isMissingVariable()) {
                                    html.push('<div class="media-right media-middle tenant-status" data-tip="Some of the required variable values have not been set."><a href="#/tenants/' + tenant.Id + '/variables/"><span class="text-warning"><i class="fa fa-warning "></i></span></a></div>');
                                }
                            }
                            html.push('</div>');
                        };

                        matrix.render();
                        matrices.push(matrix);
                    }
                });
            };

            var renderDashboard = function (data) {
                var projectGroups = _.sortBy(data.ProjectGroups, function (pg) { return pg.Name.toLowerCase(); });
                var slices = sliceByProjectGroup(data);
                var projectEnvironmentTenantIndex = getProjectEnvironmentTenantIndex(data.Projects, data.Environments, data.Tenants);

                _.each(projectGroups, function (projectGroup) {
                    var slice = slices[projectGroup.Id];

                    var matrixElement = $("<div></div>");
                    element.append(matrixElement);

                    var matrix = new Octopus.ReleaseMatrix(matrixElement, taskStatusRenderer, octoUtil);
                    matrix.environments = slice.environments;
                    matrix.rows = slice.projects;
                    matrix.heading = projectGroup.Name;
                    matrix.items = getItemsForSlice(data.Items, slice);
                    matrix.projectEnvironmentTenantIndex = projectEnvironmentTenantIndex;
                    matrix.slice = slice;
                    matrix.keyFromPair = function (env, project) { return nodeKey(env.Id, project.Id); };
                    matrix.renderRowHeading = function (project, html) {
                        html.push('<div class="media"><div class="media-left media-middle"><a href="#/projects/' + project.Slug + '"><img class="media-object" src="' + octopusClient.resolve(project.Links['Logo']) + '" /></a></div><div class="media-body media-middle"><a href="#/projects/' + project.Slug + '">' + octoUtil.escapeHtml(project.Name) + '</a></div></div>');
                    };

                    matrix.render();
                    matrices.push(matrix);
                });
            };

            var partialRender = function(data) {
                _.each(matrices, function (matrix) {
                    if (matrix.slice) {
                        matrix.items = getItemsForSlice(data.Items, matrix.slice);
                    } else {
                        matrix.items = getItemsForTenants(data.Items, data.Tenants);
                        matrix.promoteTo = data.PromoteTo;
                    }
                    matrix.update();
                });
            };

            scope.$watch("dashboardData", function (data) {
                if (!data) {
                    return;
                }

                if (fullRenderRequired(data)) {
                    fullRender(data);
                } else {
                    partialRender(data);
                }
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/dashboard/directives/fastboard.js
// module id = 6965982847499887
// module chunks = 1